// extracted by mini-css-extract-plugin
export var block = "ProjectConcept-module--block--ab671";
export var container = "ProjectConcept-module--container--fffaf";
export var fadeInAnimation = "ProjectConcept-module--fadeInAnimation--0c59b";
export var sections = "ProjectConcept-module--sections--7be34";
export var visualConcept = "ProjectConcept-module--visualConcept--d2e3f";